import React from 'react';
import { BannerWrapper } from './style';
import { ListWrapper } from '../../Components/SdkBanner/style';
import img from '../../assets/images/img11.png';

function Banner() {
	return (
		<BannerWrapper className="container">
			<div className="center">
				<div className="left">
					<h2 className="fs-sm-20">What’s Inside</h2>
					<p className="fs-sm-12">Our SDK brings everything you need to launch world-class travel solutions, straight into your app.</p>
				</div>
				<div className="middle">
					<img src={img} alt="" />
				</div>

				<div className="right">
					<ListWrapper>
						<li className="fs-sm-12">Flight Search & Booking</li>
						<li className="fs-sm-12">Hotel Listings & Reservations</li>
						<li className="fs-sm-12">Dynamic Itinerary Builder </li>
						<li className="fs-sm-12"> Real-Time Price & Availability</li>
						<li className="fs-sm-12"> Secure Payments Integration</li>
						<li className="fs-sm-12"> Multi-language & Currency Support</li>
					</ListWrapper>
				</div>
			</div>
		</BannerWrapper>
	);
}

export default Banner;
